import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Empty } from 'antd';
import './GuideContent.css';

function normalizeLineBreakText(value) {
  if (typeof value !== 'string') return value;
  return value
    .replace(/\\r\\n/g, '\n')
    .replace(/\\n/g, '\n')
    .replace(/\\r/g, '\n');
}

function hasText(value) {
  return typeof value === 'string' && value.trim() !== '';
}

const MarkdownBlock = ({ children }) => {
  if (!children) return null;
  const markdown = normalizeLineBreakText(children);
  return (
    <div className="guide-content-markdown">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{markdown}</ReactMarkdown>
    </div>
  );
};

const GuideContent = ({ content }) => {
  if (!content) {
    return <Empty description="回答案内が設定されていません" />;
  }

  const meta = Array.isArray(content.meta)
    ? content.meta.filter(
        (item) =>
          hasText(item && item.label) ||
          hasText(item && item.value) ||
          hasText(item && item.note)
      )
    : [];
  const sections = Array.isArray(content.sections)
    ? content.sections.filter(
        (item) =>
          hasText(item && item.title) ||
          hasText(item && (item.body_md || item.body))
      )
    : [];
  const points = Array.isArray(content.points)
    ? content.points.filter(
        (item) =>
          hasText(item && item.title) ||
          hasText(item && (item.body_md || item.body))
      )
    : [];
  const metaTitle = meta.some((item) =>
    ['回答対象', '回答区分'].includes(item && item.label)
  )
    ? '回答情報'
    : '形式と所要時間';

  return (
    <main className="guide-content-wrap">
      {content.eyebrow && (
        <span className="guide-content-eyebrow">
          {normalizeLineBreakText(content.eyebrow)}
        </span>
      )}
      {content.title && (
        <h1 className="guide-content-title">
          {normalizeLineBreakText(content.title)}
        </h1>
      )}

      {meta.length > 0 && (
        <section className="guide-content-card">
          <h2 className="guide-content-section-title">{metaTitle}</h2>
          <div className="guide-content-meta">
            {meta.map((item, index) => (
              <div className="guide-content-chip" key={`${item.label}-${index}`}>
                <div className="guide-content-chip-label">
                  {normalizeLineBreakText(item.label)}
                </div>
                <div className="guide-content-chip-value">
                  {normalizeLineBreakText(item.value)}
                  {item.note && (
                    <small>{normalizeLineBreakText(item.note)}</small>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {sections.map((section, index) => (
        <section className="guide-content-card" key={`${section.title}-${index}`}>
          {section.title && (
            <h2 className="guide-content-section-title">{section.title}</h2>
          )}
          <MarkdownBlock>{section.body_md || section.body}</MarkdownBlock>
        </section>
      ))}

      {points.length > 0 && (
        <section className="guide-content-card">
          <h2 className="guide-content-section-title">回答にあたっての注意事項</h2>
          <ol className="guide-content-points">
            {points.map((point, index) => (
              <li key={`${point.title}-${index}`}>
                <b>{point.title}</b>
                <MarkdownBlock>{point.body_md || point.body}</MarkdownBlock>
              </li>
            ))}
          </ol>
        </section>
      )}

      {content.note && (
        <section className="guide-content-card guide-content-note">
          <MarkdownBlock>{content.note}</MarkdownBlock>
        </section>
      )}
    </main>
  );
};

export default GuideContent;
